import './CountriesListItem.scss';
// @vendor
import React from 'react';
import PropTypes from 'prop-types';
// @components
import TextToggle from 'components/commons/textToggle/textToggle';
// @ tagging
import { EVENT_CARD_CONTROL } from 'utilities/tagging';

const CountryListItem = ({ active, code, name, onClick, disabled }) => (
    <div className="country-list-item row">
        <div className="country-list-item__label col-xs-11" >
            <span>
                {name}
            </span>
        </div>
        <div
            className="country-list-item__toggle col-xs-1"
            onClick={() => onClick && !disabled && onClick(code, active)}
          >
            <TextToggle
                checked={active}
                onClick={() => onClick && !disabled && onClick(code, active)}
                eventCategory={EVENT_CARD_CONTROL}
                eventTag={code}
                textCheck='ON'
                textUncheck='OFF'
                isCardControlSection
            />
        </div>
    </div>
);


CountryListItem.propTypes = {
    active: PropTypes.bool.isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool.isRequired
};


export default CountryListItem;
